// extracted by mini-css-extract-plugin
export var bodySections = "_6y-8";
export var gray = "_6y-7";
export var green = "_6y-4";
export var iconContainer = "_6y-9";
export var iconWidgetContainer = "_6y-1";
export var phoneIcon = "_6y-2";
export var red = "_6y-5";
export var statusDot = "_6y-3";
export var widgetContainer = "_6y-0";
export var yellow = "_6y-6";